// A member's name by user id, for the "changed by" lines of the policy pages (Signals, a rule).
import { useQuery } from '@tanstack/react-query'
import { membersQuery } from '../api/queries'
import type { Member } from '../api/types'
import type { Translator } from '../i18n'

/** `enabled` false reads no members (the sandbox). */
export function useWho(orgId: string, enabled = true) {
  const members = useQuery({ ...membersQuery(orgId), enabled })
  return (id: string | null) =>
    id ? members.data?.find((m: Member) => m.user_id === id)?.name || undefined : undefined
}

/** The "changed" line of a policy page: by whom when the author is known, else the date alone. */
export const changedLine = (t: Translator['t'], by: string | undefined, date: string): string =>
  by ? t('signals.changed', { who: by, date }) : t('signals.changedOn', { date })
